export default "__VITE_ASSET__BXinxSfJ__"